const AISafety = ({className}: {className?: string}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 175 40" className={className}>
      <g clipPath="url(#a)">
        <path
          fill="url(#b)"
          d="M81.6974 32.6155V21.634h-2.3515v-2.7536h2.3515v-5.8058c0-1.9906.4417-3.51669 1.3247-4.57834.9053-1.06163 2.2302-1.59245 3.9744-1.59245.4637 0 .9715.06635 1.5236.19905.574.1327 1.0707.35388 1.4902.66353l-1.2916 2.2228c-.1986-.19905-.4195-.33175-.6624-.3981-.2428-.08848-.4857-.1327-.7286-.1327-.817 0-1.4462.27645-1.8879.82941-.4415.5529-.6624 1.4929-.6624 2.82v5.7726h4.3388v2.7536h-4.3388v10.9815h-3.08Z"
        />
        <path
          fill="url(#c)"
          d="M59.3428 12.9088c-.817-.4203-1.7111-.7852-2.6826-1.0948-.9716-.3097-1.9209-.4645-2.8483-.4645-1.2805 0-2.3072.2986-3.0801.8958-.7507.5971-1.1261 1.3934-1.1261 2.3886 0 .752.2429 1.3934.7286 1.9243.4858.5087 1.1261.951 1.9211 1.327.7947.376 1.6227.7299 2.4839 1.0617.7507.2875 1.4903.6082 2.2189.9621.7287.3539 1.3801.7962 1.9542 1.327.5961.5309 1.0598 1.1833 1.391 1.9575.3532.774.5298 1.7361.5298 2.8862 0 1.2608-.3201 2.4109-.9604 3.4503-.6183 1.0396-1.5125 1.8579-2.6826 2.455-1.1704.5974-2.5614.8959-4.173.8959-1.0599 0-2.0757-.1216-3.0472-.3649-.9493-.2433-1.8325-.553-2.6495-.9289-.8169-.3981-1.5455-.8074-2.1859-1.2276l1.4242-2.5215c.53.3761 1.1372.7411 1.8216 1.0949.6844.3317 1.4021.6082 2.1528.8295.7506.1989 1.4793.2985 2.1857.2985.7509 0 1.4904-.1328 2.2191-.3981.7506-.2875 1.369-.7188 1.8547-1.2938.4858-.5751.7287-1.3382.7287-2.2893 0-.8184-.2209-1.4928-.6624-2.0237-.4197-.553-.9826-1.0174-1.6893-1.3934-.7064-.3982-1.457-.752-2.252-1.0617-.7506-.2874-1.5124-.5971-2.2853-.9289-.7727-.3538-1.4902-.7741-2.1526-1.2607-.6624-.5087-1.1924-1.128-1.5899-1.8578-.3974-.7299-.596-1.6146-.596-2.6541 0-1.2607.298-2.3556.8941-3.2845.6183-.951 1.4573-1.69198 2.5171-2.22279 1.0598-.55295 2.2742-.85152 3.6432-.89577 1.5456 0 2.9035.188 4.0737.564 1.1923.376 2.241.84047 3.1463 1.39336l-1.2255 2.4551Z"
        />
        <path fill="url(#d)" d="M136.74 13.2351h-1.558v2.893h1.558v-2.893Z" />
        <path fill="url(#e)" d="M131.288 29.3096h-3.301v3.3062h3.301v-3.3062Z" />
        <path
          fill="url(#f)"
          fillRule="evenodd"
          d="M65.5041 32.1177c1.0599.553 2.23.8295 3.5107.8295.7947 0 1.5125-.1107 2.1526-.3318.6403-.2433 1.2035-.5418 1.6893-.8958.5078-.3539.9052-.6967 1.1921-1.0285.0999-.1142.1882-.2216.2649-.3221v2.2464h3.0803v-13.735h-2.8483l-.2233 2.1864c-.4567-.7107-1.0889-1.3289-1.8963-1.8546-.8833-.5972-1.9651-.8958-3.2458-.8958-1.2805 0-2.4617.2986-3.5438.8958-1.0598.5971-1.9099 1.4597-2.5501 2.5878-.6403 1.1057-.9606 2.4218-.9606 3.9478 0 1.5483.2983 2.8643.8944 3.948.6181 1.0617 1.4461 1.8689 2.4839 2.4219Zm6.4251-2.1565c-.6181.2876-1.3136.4314-2.0865.4314-.817 0-1.5788-.2102-2.2852-.6304-.7066-.4202-1.2696-.9952-1.689-1.7251-.4195-.7299-.6295-1.5371-.6295-2.4219 0-.9511.1989-1.7806.5963-2.4882.4195-.7079.9715-1.2608 1.6559-1.6588.6844-.3981 1.4353-.5973 2.2523-.5973.7506 0 1.435.1439 2.0533.4313.6181.2654 1.1482.6526 1.5897 1.1613.4415.4866.7506 1.0616.9272 1.7251v2.6873c-.1543.7298-.4415 1.3602-.8609 1.8911-.3975.5086-.9053.9068-1.5236 1.1942Z"
          clipRule="evenodd"
        />
        <path
          fill="url(#g)"
          fillRule="evenodd"
          d="M92.5422 32.0181c1.1259.6194 2.4729.9291 4.0405.9291.8169 0 1.645-.1439 2.484-.4314.861-.2876 1.6343-.6635 2.3183-1.128l-1.4242-2.2891c-.4857.3538-1.0156.6415-1.5896.8625-.5521.2212-1.1261.3318-1.7222.3318-.8832 0-1.6782-.199-2.3846-.5972-.6473-.3975-1.1664-.9235-1.5571-1.5781l10.8637-3.8295c-.42-1.8579-1.226-3.3177-2.418-4.3793-1.1922-1.0617-2.6935-1.5925-4.504-1.5925-1.4131 0-2.6937.3318-3.8419.9953-1.1481.6635-2.0645 1.5483-2.7489 2.654-.6846 1.106-1.0266 2.3334-1.0266 3.6827 0 1.4155.298 2.6761.8941 3.7821.6183 1.0837 1.4904 1.9464 2.6165 2.5876Zm-.4512-5.7715c-.0304-.2462-.0457-.5009-.0457-.7642 0-.9068.1878-1.714.563-2.4218.3754-.7078.8943-1.2606 1.5567-1.6588.6624-.4202 1.413-.6303 2.2522-.6303.9936 0 1.7994.2763 2.4177.8293.5708.4901.9909 1.0652 1.2601 1.7249l-8.004 2.9209Z"
          clipRule="evenodd"
        />
        <path
          fill="url(#h)"
          d="M106.602 12.8423h3.08v6.1044h3.323l-.031-.0664h3.477l4.418 9.8046 4.359-9.8046h2.848l-8.843 20.3372h-3.047l3.126-7.0316-5.854-12.2888v1.4715h-3.776v11.2468h-3.08V21.3686h-2.517v-2.4219h2.517v-6.1044Z"
        />
        <path fill="url(#i)" d="M135.182 19.6436h1.556v12.9719h-1.556V19.6436Z" />
        <path
          fill="url(#j)"
          d="m141.446 22.5303-.117-2.8868h-1.358v12.972h1.557v-6.967c0-.9955.221-1.8691.662-2.621.464-.752 1.071-1.3382 1.822-1.7584.75-.4202 1.556-.6303 2.417-.6303.972.0221 1.712.3097 2.219.8627.508.5528.773 1.2495.795 2.0901v9.0239h1.59v-9.4553c-.022-1.1501-.408-2.0791-1.159-2.7868-.751-.7299-1.733-1.0948-2.948-1.0948-1.28 0-2.451.3317-3.511.9952-.912.5642-1.568 1.3163-1.969 2.2565Z"
        />
        <path
          fill="url(#k)"
          d="M155.131 32.6155V21.1034h-2.253v-1.4267h2.253V13.141c0-2.079.353-3.57197 1.059-4.4788.729-.92893 1.8-1.3934 3.213-1.3934.309 0 .64.04425.993.13272.354.06635.674.188.961.36493l-.662 1.128c-.155-.1106-.332-.188-.53-.23225-.177-.06635-.387-.09953-.63-.09953-.949 0-1.667.33178-2.152.9953-.464.66353-.696 1.84683-.696 3.54983v6.5689h4.339v1.4267h-4.339v11.5121h-1.556Z"
        />
        <path
          fill="url(#l)"
          fillRule="evenodd"
          d="M161.508 22.5961c-.596 1.0395-.894 2.1896-.894 3.4503 0 1.3272.298 2.5105.894 3.5499.619 1.0175 1.446 1.8247 2.484 2.4218 1.038.5751 2.219.8627 3.544.8627 1.303 0 2.473-.2986 3.511-.8959 1.06-.6192 1.887-1.4486 2.484-2.488.596-1.0396.894-2.1897.894-3.4505 0-1.2607-.298-2.4108-.894-3.4503-.597-1.0394-1.414-1.8578-2.451-2.455-1.038-.6193-2.219-.9289-3.544-.9289-1.303 0-2.484.3096-3.544.9289-1.038.5972-1.865 1.4156-2.484 2.455Zm1.358 6.2703c-.463-.8404-.695-1.7693-.695-2.7868 0-.951.232-1.8468.695-2.6873.464-.8404 1.093-1.515 1.888-2.0237.817-.5309 1.733-.7962 2.749-.7962.993 0 1.888.2544 2.683.763.816.4866 1.457 1.1501 1.921 1.9906.485.8183.728 1.7362.728 2.7536 0 1.0175-.243 1.9464-.728 2.7868-.464.8183-1.105 1.4709-1.921 1.9575-.795.4866-1.69.7299-2.683.7299-.994 0-1.899-.2433-2.716-.7299-.795-.4866-1.435-1.1392-1.921-1.9575Z"
          clipRule="evenodd"
        />
        <path
          fill="url(#m)"
          fillRule="evenodd"
          d="M2.38659 34.4636c0-1.2765-1.06351-2.3111-2.3754015-2.3111l-.0001259-2.6266c1.3118874 0 2.3755274-1.0346 2.3755274-2.3111 0-1.2763-1.06351-2.311-2.3754015-2.311l-.0001259-2.627c1.3118874 0 2.3755274-1.0346 2.3755274-2.3111 0-1.2763-1.06351-2.311-2.3754015-2.311l-.0001259-2.6266c1.3118874 0 2.3755274-1.0347 2.3755274-2.311 0-1.2764-1.06351-2.3111-2.3754015-2.3111L.0110626 7.77903c1.3118874 0 2.3755274-1.0347 2.3755274-2.31109 0-1.27637-1.06351-2.31107-2.3754015-2.31107L.0110626.0351562H3.21969C3.21977 1.31146 4.28325 2.34608 5.59507 2.34608c1.31185 0 2.37533-1.03462 2.37541-2.3109238h2.70002C10.6706 1.31146 11.7341 2.34608 13.0459 2.34608c1.3118 0 2.3753-1.03462 2.3754-2.3109238h2.6996C18.121 1.31146 19.1844 2.34608 20.4963 2.34608c1.3118 0 2.3753-1.03462 2.3753-2.3109238h2.7001c0 1.2763038 1.0636 2.3109238 2.3753 2.3109238 1.312 0 2.3753-1.03462 2.3755-2.3109238h2.6995C33.0222 1.31146 34.0856 2.34608 35.3975 2.34608c1.3118 0 2.3753-1.03462 2.3753-2.3109238h3.209V3.15687c-1.312.00006-2.3753 1.03474-2.3753 2.31107 0 1.27635 1.0633 2.31103 2.3753 2.31109V10.406c-1.312 0-2.3753 1.0347-2.3753 2.3111 0 1.2763 1.0633 2.311 2.3753 2.311v2.6266c-1.312 0-2.3753 1.0347-2.3753 2.311s1.0633 2.3111 2.3753 2.3111v2.627c-1.312 0-2.3753 1.0347-2.3753 2.311 0 1.2765 1.0633 2.3111 2.3753 2.3111v2.6266c-1.312 0-2.3753 1.0346-2.3753 2.3111 0 1.2763 1.0633 2.311 2.3753 2.311v3.122h-3.209c0-1.2763-1.0635-2.3111-2.3753-2.3111-1.3119 0-2.3755 1.0346-2.3755 2.3109l-2.6995.0002c0-1.2763-1.0635-2.3111-2.3755-2.3111-1.3117 0-2.3753 1.0346-2.3753 2.3109l-2.7001.0002c0-1.2763-1.0635-2.3111-2.3753-2.3111-1.3119 0-2.3754 1.0346-2.3754 2.3109l-2.6996.0002c0-1.2763-1.0635-2.3111-2.3754-2.3111s-2.3754 1.0346-2.3754 2.3109l-2.70002.0002c0-1.2763-1.06352-2.3111-2.37541-2.3111s-2.37538 1.0346-2.37538 2.3109l-3.2086274.0002v-3.122c1.3118874 0 2.3755274-1.0347 2.3755274-2.311ZM33.9005 8.59225h-5.5052V32.2727h5.5052V8.59225ZM16.7794 7.6592 6.13466 32.2727h4.58494l1.9079-4.6332h7.8473l1.8193 4.6332h5.3866L17.0359 7.6592h-.2565Zm2.154 16.0552-2.289-5.8293-2.4005 5.8293h4.6895Z"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <linearGradient
          id="b"
          x1="72.9962"
          x2="135.313"
          y1="84.9879"
          y2="-48.4708"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F0668" />
          <stop offset=".311563" stopColor="#12A391" />
          <stop offset="1" stopColor="#4F0668" />
        </linearGradient>
        <linearGradient
          id="c"
          x1="72.9962"
          x2="135.313"
          y1="84.9879"
          y2="-48.4708"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F0668" />
          <stop offset=".311563" stopColor="#12A391" />
          <stop offset="1" stopColor="#4F0668" />
        </linearGradient>
        <linearGradient
          id="d"
          x1="72.9961"
          x2="135.313"
          y1="84.988"
          y2="-48.4708"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F0668" />
          <stop offset=".311563" stopColor="#12A391" />
          <stop offset="1" stopColor="#4F0668" />
        </linearGradient>
        <linearGradient
          id="e"
          x1="72.9961"
          x2="135.313"
          y1="84.9879"
          y2="-48.4709"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F0668" />
          <stop offset=".311563" stopColor="#12A391" />
          <stop offset="1" stopColor="#4F0668" />
        </linearGradient>
        <linearGradient
          id="f"
          x1="72.9962"
          x2="135.313"
          y1="84.9878"
          y2="-48.4709"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F0668" />
          <stop offset=".311563" stopColor="#12A391" />
          <stop offset="1" stopColor="#4F0668" />
        </linearGradient>
        <linearGradient
          id="g"
          x1="72.9962"
          x2="135.313"
          y1="84.9878"
          y2="-48.4709"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F0668" />
          <stop offset=".311563" stopColor="#12A391" />
          <stop offset="1" stopColor="#4F0668" />
        </linearGradient>
        <linearGradient
          id="h"
          x1="72.9962"
          x2="135.313"
          y1="84.9878"
          y2="-48.4709"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F0668" />
          <stop offset=".311563" stopColor="#12A391" />
          <stop offset="1" stopColor="#4F0668" />
        </linearGradient>
        <linearGradient
          id="i"
          x1="72.9963"
          x2="135.313"
          y1="84.9879"
          y2="-48.4707"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F0668" />
          <stop offset=".311563" stopColor="#12A391" />
          <stop offset="1" stopColor="#4F0668" />
        </linearGradient>
        <linearGradient
          id="j"
          x1="72.9963"
          x2="135.313"
          y1="84.9879"
          y2="-48.4708"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F0668" />
          <stop offset=".311563" stopColor="#12A391" />
          <stop offset="1" stopColor="#4F0668" />
        </linearGradient>
        <linearGradient
          id="k"
          x1="72.9962"
          x2="135.313"
          y1="84.9879"
          y2="-48.4708"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F0668" />
          <stop offset=".311563" stopColor="#12A391" />
          <stop offset="1" stopColor="#4F0668" />
        </linearGradient>
        <linearGradient
          id="l"
          x1="72.9963"
          x2="135.313"
          y1="84.9878"
          y2="-48.4709"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F0668" />
          <stop offset=".311563" stopColor="#12A391" />
          <stop offset="1" stopColor="#4F0668" />
        </linearGradient>
        <linearGradient
          id="m"
          x1="72.9962"
          x2="135.313"
          y1="84.9878"
          y2="-48.4709"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F0668" />
          <stop offset=".311563" stopColor="#12A391" />
          <stop offset="1" stopColor="#4F0668" />
        </linearGradient>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h174.545v40H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
export const AISafetyIcon = AISafety
